import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import { GetAnnouncementResponse } from '@/modules/announcement/type'
import AnnouncementBox from '../AnnouncementBox'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'

interface AnnouncementListingProps {
	data: GetAnnouncementResponse
	fetchNextPage: () => void
	hasMore: boolean
}

export default function AnnouncementListing({
	data,
	fetchNextPage,
	hasMore,
}: AnnouncementListingProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_ANNOUNCEMENT,
	)
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`หน้าแรก`} description="ประกาศสำหรับหลังบ้าน" />
				{hasWritePermission && (
					<Button asChild variant="default">
						<Link to="/operator/home-page/create-announcement">
							สร้างประกาศหลังบ้าน
						</Link>
					</Button>
				)}
			</div>
			<Separator />
			<AnnouncementBox
				data={data}
				fetchNextPage={fetchNextPage}
				hasMore={hasMore}
			/>
		</div>
	)
}
